import React, { Component, createRef } from "react";
import { BsyUtils } from "../../../utils/Utils";
import { BsyFilterText } from "../../filterField/BsyFilterText";
import { BsyFilterComboCheck } from "../../filterField/BsyFilterComboCheck";
import { BsyFilterTextArea } from "../../filterField/BsyFilterTextArea";
import { BsyFilterFile } from "../../filterField/BsyFilterFile";
import { BsyFilterUser } from "../../filterField/BsyFilterUser";
import { BsyFilterUserGroup } from "../../filterField/BsyFilterUserGroup";
import { BsyFilterAddress } from "../../filterField/BsyFilterAddress";
import { BsyFilterNumber } from "../../filterField/BsyFilterNumber";
import { BsyFilterFlowState } from "../../filterField/BsyFilterFlowState";
import { BsyFilterNode } from "../../filterField/BsyFilterNode";
import { BsyFilterDeptGroup } from "../../filterField/BsyFilterDeptGroup";
import { BsyFilterDept } from "../../filterField/BsyFilterDept";
import { BsyFilterDate } from "../../filterField/BsyFilterDate";
import BsyMsgBubble from "../../BsyMsgBubble";
import "./index.css";
import { BsyFilterFlowNode } from "../../filterField/BsyFilterFlowNode";
import { BsyFilterFlowBackNode } from "../../filterField/BsyFilterFlowBackNode";
import { BsyFilterFlowDecision } from "../../filterField/BsyFilterFlowDecision";
import BsySearchInput from "../../BsySearchInput";
import { BsyConfig } from "../../../global/BsyConfig";

class BsyDashboardFlowFilter extends Component {
  static defaultProps = {
    show: true,
  };

  constructor(props) {
    super(props);

    this.state = {
      allcount: props.allcount,
      show: !props.entryId ? false : props.show,
      fields: props.fields, //表单字段
      filter: props.filter, //筛选字段
      filters: [],
      seachSwitch: !window.hasOwnProperty("flow_search_switch")
        ? true
        : window.flow_search_switch,
      flowType: props.flowType,
      flowMode: props.flowType === "cc" ? "isread0" : "all",
      excludeField: [
        "separator",
        "button",
        "dataload",
        "linkquery",
        "linkdata",
      ],
      systemField: [
        "createTime",
        "backflowid",
        "flowNode",
        "flowcreator",
        "flowState",
      ],
      isBatchForward: props.isBatchForward,
      updateTime: props.updateTime,
    };

    this.search = props.search || "";
    this.elementRef = createRef();
  }

  filterMap = {}; //记录筛选条件的结构
  contextMap = {}; //记录筛选条件的句柄
  filter = {}; //记录具体的筛选条件

  loadSeachSwitch = () => {
    if (!window.hasOwnProperty("flow_search_switch")) {
      React.axios("/data/flow_search_switch", {})
        .then((res) => {
          if (res.data) {
            window.flow_search_switch = res.data.flow_search_switch;
            this.setState(
              {
                seachSwitch: res.data.flow_search_switch == 0 ? false : true,
              },
              () => {}
            );
            this.loadTodoCount();
          }
        })
        .catch((res) => {});
    }
  };

  componentDidMount() {
    if (this.props.getContext) {
      this.props.getContext(this);
    }
    this.loadSeachSwitch();
    this.loadTodoCount();
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    //防止多次重复 setState
    let props = {};
    if (!BsyUtils.compare(nextProps.filter, this.state.filter)) {
      props.filter = nextProps.filter;
    }
    if (nextProps.isBatchForward !== this.state.isBatchForward) {
      props.isBatchForward = nextProps.isBatchForward;
    }
    if (nextProps.updateTime !== this.state.updateTime) {
      props.updateTime = nextProps.updateTime;
    }

    if (!BsyUtils.compare(nextProps.fields, this.state.fields)) {
      props.fields = [...nextProps.fields];
      this.filterMap = {};
      this.contextMap = {};
      this.loadTodoCount();
    }

    if (!BsyUtils.isObjectEmpty(props)) {
      this.setState({
        ...props,
      });
    }
  }

  readAll = () => {
    let that = this;
    var items = this.props.getFlowData();

    let data = {
      appId: that.props.appId,
      entryId: that.props.entryId,
      formId: that.props.entryId,
      list: [],
    };
    BsyUtils.forEach(items, (index, item) => {
      data.list.push({
        appId: that.props.appId,
        entryId: that.props.entryId,
        formId: that.props.entryId,
        _id: item._id,
      });
    });
    if (data.list.length === 0) {
      return;
    }

    React.axios("/data/flow_set_read", {
      ...data,
    })
      .then((res) => {
        this.onLoadFlowList();
      })
      .catch((res) => {});
  };

  loadTodoCount = () => {
    let abb = {
      appId: this.props.appId,
      entryId: this.props.entryId,
      formId: this.props.entryId,
      hascount: true,
      limit: 20,
      cacheKey: "loadTodoCountAll",
      skip: 0,
      sort: { updateTime: -1 },
      type: this.state.flowType,
    };
    switch (this.state.flowType) {
      case "todo": {
        React.axios(`/dashboard/app/${this.props.appId}/workflow/query_data`, {
          ...abb,
          filter: {
            cond: [
              {
                field: "entryId",
                type: "flowentry",
                hasEmpty: false,
                method: "eq",
                value: [this.props.entryId],
              },
            ],
            rel: "and",
          },
        }).then((res0) => {
          this.setState({
            allcount: res0.data.count,
          });
        });
        break;
      }
      case "cc": {
        React.axios(`/dashboard/app/${this.props.appId}/workflow/query_data`, {
          ...abb,
          filter: {
            cond: [
              {
                field: "entryId",
                type: "flowentry",
                hasEmpty: false,
                method: "eq",
                value: [this.props.entryId],
              },
            ],
            rel: "and",
          },
        }).then((res0) => {
          this.setState({
            allcount: res0.data.count,
            flowMode: "isread0",
            // isread0: res2.data.count,
            // isread1: res1.data.count,
          });
          //     })
          // })
        });
        break;
      }
      default:
        React.axios(`/dashboard/app/${this.props.appId}/workflow/query_data`, {
          ...abb,
          filter: {
            cond: [
              {
                field: "entryId",
                type: "flowentry",
                hasEmpty: false,
                method: "eq",
                value: [this.props.entryId],
              },
            ],
            rel: "and",
          },
        }).then((res0) => {
          this.setState({
            allcount: res0.data.count,
          });
        });
    }
  };

  getContext = (e) => {
    this.contextMap[e.options.widgetId] = e;
  };

  loadFilterList = (res) => {
    // console.log(res)
    let filterType = BsyUtils._widget_dash_filter(res.type);
    res.filterType = filterType;
    switch (filterType) {
      case "combo_filter":
      case "sn_filter":
      case "radiogroup_filter":
      case "text_filter": {
        return (
          <BsyFilterText
            {...res}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterText>
        );
      }
      case "checkboxgroup_filter":
      case "combocheck_filter": {
        return (
          <BsyFilterComboCheck
            {...res}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterComboCheck>
        );
      }
      case "textarea_filter": {
        return (
          <BsyFilterTextArea
            {...res}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterTextArea>
        );
      }
      case "upload_filter":
      case "image_filter":
      case "signature_filter":
      case "filelist_filter": {
        return (
          <BsyFilterFile
            {...res}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterFile>
        );
      }
      case "flownode":
      case "backflowid": {
        return (
          <BsyFilterNode
            {...res}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterNode>
        );
      }
      case "flowcreator_filter":
      case "user_filter": {
        return (
          <BsyFilterUser
            {...res}
            type={filterType}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterUser>
        );
      }
      case "number_filter": {
        return (
          <BsyFilterNumber
            {...res}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterNumber>
        );
      }
      case "flowstate_filter": {
        return (
          <BsyFilterFlowState
            {...res}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterFlowState>
        );
      }
      case "flowdecision_filter": {
        return (
          <BsyFilterFlowDecision
            {...res}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterFlowDecision>
        );
      }
      case "location_filter":
      case "address_filter": {
        return (
          <BsyFilterAddress
            {...res}
            getContext={this.getContext}
            format={"pcd"}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterAddress>
        );
      }

      case "address_province_filter": {
        return (
          <BsyFilterAddress
            {...res}
            format={"p"}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterAddress>
        );
      }

      case "address_city_filter": {
        return (
          <BsyFilterAddress
            {...res}
            format={"pc"}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterAddress>
        );
      }

      case "usergroup_filter": {
        return (
          <BsyFilterUserGroup
            {...res}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterUserGroup>
        );
      }

      case "dept_filter": {
        return (
          <BsyFilterDept
            {...res}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterDept>
        );
      }
      case "deptgroup_filter": {
        return (
          <BsyFilterDeptGroup
            {...res}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterDeptGroup>
        );
      }
      case "flownode_filter": {
        return (
          <BsyFilterFlowNode
            {...res}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterFlowNode>
        );
      }

      case "backflowid_filter": {
        return (
          <BsyFilterFlowBackNode
            {...res}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterFlowBackNode>
        );
      }

      case "date_filter":
      case "datetime_filter":
      case "datemonth_filter":
      case "dateyear_filter": {
        return (
          <BsyFilterDate
            {...res}
            getContext={this.getContext}
            onStopEdit={this.onFilterStopEdit}
          ></BsyFilterDate>
        );
      }
      default:
    }
  };

  onFilterStopEdit = (t, e) => {
    let a = t.value;
    let method = t.method;
    this._updateFilter(
      e.widgetId,
      {
        ...e,
        ...{
          method: method,
        },
      },
      a
    );

    this.filterMap[e.widgetId].defaultConfig = this._margedefaultConfig(
      this.filter[e.widgetId]
    );
    let d = [];
    BsyUtils.forEach(this.state.filter, (index, data) => {
      if (data) d.push(this.filter[data.field]);
    });

    this.setState(
      {
        filter: [...d],
      },
      () => {}
    );
  };
  //转换默认值的格式
  _margedefaultConfig = (filter) => {
    if (!BsyUtils.checkFilterValid(filter)) {
      return {};
    }
    let filterType = BsyUtils._widget_dash_filter(filter.type);
    switch (filterType) {
      case "backflowid_filter":
      case "flownode_filter": {
        return {
          value: filter.value,
        };
      }
      case "flowcreator_filter":
      case "dept_filter":
      case "user_filter":
      case "text_filter": {
        switch (filter.method) {
          case BsyConfig().CONST.FILTER_METHOD.LK:
          case BsyConfig().CONST.FILTER_METHOD.ULK:
          case BsyConfig().CONST.FILTER_METHOD.EQ:
          case BsyConfig().CONST.FILTER_METHOD.NE: {
            return {
              value: filter.value[0],
            };
          }
          case BsyConfig().CONST.FILTER_METHOD.IN:
          case BsyConfig().CONST.FILTER_METHOD.NIN: {
            return {
              parentDepts: filter.parentDepts ? filter.parentDepts : [],
              hasCurrentDept: filter.hasCurrentDept
                ? filter.hasCurrentDept
                : false,
              hasCurrentParDept: filter.hasCurrentParDept
                ? filter.hasCurrentParDept
                : false,
              hasCurrentSubDept: filter.hasCurrentSubDept
                ? filter.hasCurrentSubDept
                : false,
              hasCurrentUser: filter.hasCurrentUser
                ? filter.hasCurrentUser
                : false,
              hasEmpty: filter.hasEmpty ? filter.hasEmpty : false,
              items: [...filter.value],
            };
          }
          default:
        }
        break;
      }
      case "textarea_filter": {
        switch (filter.method) {
          case BsyConfig().CONST.FILTER_METHOD.LK:
          case BsyConfig().CONST.FILTER_METHOD.ULK: {
            return {
              value: filter.value[0],
            };
          }
          default:
        }
        break;
      }
      case "number_filter": {
        switch (filter.method) {
          case BsyConfig().CONST.FILTER_METHOD.EQ:
          case BsyConfig().CONST.FILTER_METHOD.NE:
          case BsyConfig().CONST.FILTER_METHOD.GT:
          case BsyConfig().CONST.FILTER_METHOD.GTE:
          case BsyConfig().CONST.FILTER_METHOD.LT:
          case BsyConfig().CONST.FILTER_METHOD.LTE: {
            return {
              value: filter.value[0],
            };
          }
          case BsyConfig().CONST.FILTER_METHOD.RG: {
            return {
              min: filter.value[0],
              max: filter.value[1],
            };
          }
          default:
        }
        break;
      }
      case "usergroup_filter":
      case "deptgroup_filter":
      case "combocheck_filter": {
        switch (filter.method) {
          case BsyConfig().CONST.FILTER_METHOD.EQ:
          case BsyConfig().CONST.FILTER_METHOD.ALL:
          case BsyConfig().CONST.FILTER_METHOD.IN: {
            return {
              parentDepts: filter.parentDepts ? filter.parentDepts : [],
              hasCurrentDept: filter.hasCurrentDept
                ? filter.hasCurrentDept
                : false,
              hasCurrentParDept: filter.hasCurrentParDept
                ? filter.hasCurrentParDept
                : false,
              hasCurrentSubDept: filter.hasCurrentSubDept
                ? filter.hasCurrentSubDept
                : false,
              hasCurrentUser: filter.hasCurrentUser
                ? filter.hasCurrentUser
                : false,
              hasEmpty: filter.hasEmpty ? filter.hasEmpty : false,

              items: [...filter.value],
            };
          }
          default:
        }
        break;
      }
      case "date_filter":
      case "datetime_filter":
      case "datemonth_filter":
      case "dateyear_filter": {
        switch (filter.method) {
          case BsyConfig().CONST.FILTER_METHOD.EQ:
          case BsyConfig().CONST.FILTER_METHOD.NE:
          case BsyConfig().CONST.FILTER_METHOD.GTE:
          case BsyConfig().CONST.FILTER_METHOD.LTE: {
            return {
              value: filter.value[0]
                ? filter.value[0]
                : null,
            };
          }
          case BsyConfig().CONST.FILTER_METHOD.RG: {
            return {
              min: filter.value[0] ? filter.value[0] : null,
              max: filter.value[1] ? filter.value[1] : null,
            };
          }
          case BsyConfig().CONST.FILTER_METHOD.FM: {
            return filter.value;
          }
          default:
        }
        break;
      }

      case "location_filter":
      case "address_filter":
      case "address_province_filter":
      case "address_city_filter":
      case "address_district_filter":
        switch (filter.method) {
          case BsyConfig().CONST.FILTER_METHOD.ALL:
          case BsyConfig().CONST.FILTER_METHOD.NIN: {
            return {
              province: filter.value[0],
              city: filter.value[1],
              district: filter.value[2],
            };
          }
          default:
        }
        break;
      default: {
        if (filter && filter.value) {
          return {
            value: filter.value[0],
          };
        }
        break;
      }
    }
  };

  _getComboCheckFilter = (t, e) => {
    let i = (e && e.items) || (e && e.value);
    let r = {
      type: t,
      hasEmpty: !(!e || !e.hasEmpty),
      value: !BsyUtils.isObjectEmpty(i) ? BsyUtils.makeArray(i) : [],
      hasCurrentDept: !(!e || !e.hasCurrentDept),
      hasCurrentUser: !(!e || !e.hasCurrentUser),
      hasCurrentSubDept: !(!e || !e.hasCurrentSubDept),
      hasCurrentParDept: !(!e || !e.hasCurrentParDept),
    };
    if (e) {
      r.parentDepts = e.parentDepts ? BsyUtils.makeArray(e.parentDepts) : [];
    }
    switch (r.type) {
      case "user":
      case "usergroup": {
        delete r.parentDepts;
        delete r.hasCurrentDept;
        delete r.hasCurrentSubDept;
        delete r.hasCurrentParDept;
        break;
      }
      case "deptgroup":
      case "dept": {
        delete r.hasCurrentUser;
        break;
      }
      default: {
        delete r.parentDepts;
        delete r.hasCurrentDept;
        delete r.hasCurrentSubDept;
        delete r.hasCurrentParDept;
        delete r.parentDepts;
        delete r.hasCurrentUser;
        break;
      }
    }
    return r;
  };

  _initFilter = (res) => {
    let n = {
      value: null,
      field: res.name,
      fields: [res],
      hasEmpty: false,
      type: res.type,
    };
    switch (res.type) {
      case "text":
      case "radiogroup":
      case "combo":
      case "sn":
        n.method = "in";
        break;
      case "textarea":
        n.method = BsyConfig().CONST.FILTER_METHOD.LK;
        break;
      case "combocheck":
      case "checkboxgroup":
        n.method = BsyConfig().CONST.FILTER_METHOD.ALL;
        break;
      case "number":
        n.type = "number";
        n.method = BsyConfig().CONST.FILTER_METHOD.RG;
        break;
      case "datetime":
        n.type = "datetime";
        n.method = BsyConfig().CONST.FILTER_METHOD.RG;
        break;
      case "address":
      case "location":
        n.type = "address";
        n.method = BsyConfig().CONST.FILTER_METHOD.ALL;
        break;
      case "user":
        n.method = BsyConfig().CONST.FILTER_METHOD.IN;
        n.value = [];
        n.hasCurrentUser = false;
        break;
      case "dept":
        n.method = BsyConfig().CONST.FILTER_METHOD.IN;
        n.value = [];
        n.hasCurrentDept = false;
        n.hasCurrentParDept = false;
        n.hasCurrentSubDept = false;
        n.parentDepts = [];
        break;
      case "usergroup":
        n.method = BsyConfig().CONST.FILTER_METHOD.ALL;
        n.value = [];
        n.hasCurrentUser = false;
        break;
      case "deptgroup":
        n.method = BsyConfig().CONST.FILTER_METHOD.ALL;
        n.value = [];
        n.hasCurrentDept = false;
        n.hasCurrentParDept = false;
        n.hasCurrentSubDept = false;
        n.parentDepts = [];
        break;
      case "flowstate":
        n.type = "flowstate";
        n.method = BsyConfig().CONST.FILTER_METHOD.EQ;
        break;
      case "upload":
      case "image":
        n.type = res.type;
        n.method = "not_empty";
        break;
      case "signature":
        n.type = "signature";
        n.method = "not_empty";
        break;
      default:
    }
    return { ...n };
  };
  _updateFilter = (t, e, i) => {
    let a = e.fields[0],
      n = {};
    this.filter[t] = this.filter[t] || {};
    n.method = e.method || BsyUtils.getDashDefaultFilterMethod(a && a.type);
    n.fields = e.fields;
    n.field = t;
    n.fields[0].formId = this.props.formId;
    if (a) {
      switch (a.type) {
        case "text":
        case "radiogroup":
        case "combo":
        case "sn":
          n = { ...n, ...this._getComboCheckFilter("text", i) };
          break;
        case "textarea":
          n.type = "textarea";
          let s = i && i.items ? i.items[0] : i && i.value;
          n.value = s ? BsyUtils.makeArray(s) : [];
          break;
        case "combocheck":
        case "checkboxgroup":
          n = { ...n, ...this._getComboCheckFilter("combocheck", i) };
          break;
        case "number":
          n.type = "number";
          i &&
            (n.value = BsyUtils.isEmpty(i.value) ? [i.min, i.max] : [i.value]);
          break;
        case "datetime":
          n.type = "datetime";
          let o = "yyyy-MM-dd";
          switch (e.type) {
            case "datetime_filter": {
              o = "yyyy-MM-dd HH:mm:ss";

              break;
            }
            case "datemonth_filter": {
              o = "yyyy-MM";
              break;
            }
            case "dateyear_filter": {
              o = "yyyy";
              break;
            }
            default:
          }
          // let o = "datetime_filter" === e.type ? "yyyy-MM-dd HH:mm:ss" : "yyyy-MM-dd";
          i && i.value
            ? (n.value = [typeof i.value === 'string' ? i.value : BsyUtils.date2Str(new Date(i.value), o)])
            : i && i.mode
            ? (n.value = [i])
            : (n.value = [
                i && i.min ? typeof i.min === 'string' ? i.min : BsyUtils.date2Str(new Date(i.min), o) : null,
                i && i.max ? typeof i.max === 'string' ? i.max : BsyUtils.date2Str(new Date(i.max), o) : null,
              ]);
          break;
        case "address":
        case "location":
          n.type = "address";
          n.value = i ? [i.province, i.city, i.district] : [];
          break;
        case "user":
        case "usergroup":
        case "dept":
        case "deptgroup":
        case "flowcreator":
          n = { ...n, ...this._getComboCheckFilter(a.type, i) };
          break;
        case "flowstate":
        case "flowState":
          n.type = "flowstate";
          let e1 = (i && i.items) || (i && i.value);
          n.value = !BsyUtils.isObjectEmpty(e1) ? BsyUtils.makeArray(e1) : [];
          break;
        case "flowdecision":
          n.type = "flowdecision";
          let e2 = (i && i.items) || (i && i.value);
          n.value = !BsyUtils.isObjectEmpty(e2) ? BsyUtils.makeArray(e2) : [];
          break;
        case "backflowid":
          n.type = "backflowid";
          n.value = i;
          break;
        case "flownode":
          n.type = "flownode";
          n.value = i;
          break;
        case "upload":
        case "image":
          n.type = a.type;
          break;
        case "signature":
          n.type = "signature";
          break;
        default:
          break;
      }
    }
    this.filter[t] = { ...this.filter[t], ...n };
    // $.extend(, n)
  };

  switchShowHide = () => {
    const { show } = this.state;
    this.setState(
      {
        show: !show,
      },
      () => {
        this.props.onFilterShow && this.props.onFilterShow(this.state.show);
      }
    );
  };

  onSelectField = () => {
    return () => {
      this.props.onLoadFilter && this.props.onLoadFilter();
    };
  };

  onSetFieldFilter = (e, res) => {
    e.currentTarget.classList.add("disabled");
    let filter = [...this.state.filter];
    let n = this._initFilter(res);
    this.filter[n.field] = n;
    filter.push(n);
    this.setState(
      {
        filter: filter,
      },
      () => {}
    );
  };

  selectField = (event) => {
    const { filter, fields, excludeField, systemField } = this.state;
    let widgetList = [];
    BsyUtils.forEach(filter, (index, data) => {
      if (data) widgetList.push(data.field || data.name);
    });

    BsyMsgBubble({
      anchor: event.currentTarget,
      contentHTML: (s) => {
        return (
          <div
            className="selectFieldPane"
            style={{
              minWidth: 180,
              maxWidth: 300,
            }}
          >
            <div className="fieldList">
              {fields.map((res) => {
                return (
                  excludeField.indexOf(res.type) === -1 && (
                    <div
                      onClick={(e) => {
                        s.closeAlter();
                        this.onSetFieldFilter(e, res);
                      }}
                      className={
                        "fieldItem" +
                        (widgetList.indexOf(res.name) > -1 ? " disabled" : "") +
                        (systemField.indexOf(res.name) > -1 ? " blue" : "")
                      }
                    >
                      <span>{res.text}</span>
                    </div>
                  )
                );
              })}
            </div>
          </div>
        );
      },
      text4Cancel: null,
      text4Ok: null,
      hAdjust: -5,
      contentPadding: 0,
      dockPosition: "center",
    });
  };

  removeFilterItem = (v, k) => {
    return () => {
      let { filter } = this.state;
      let dfilter = [];
      BsyUtils.forEach(filter, (index, data) => {
        if (data) {
          if (v.widgetId == data.field) {
            delete this.filter[v.widgetId];
            delete this.filterMap[v.widgetId];
            delete this.getContext[v.widgetId];
          } else {
            dfilter.push(this.filter[data.field]);
          }
        }
      });
      this.setState(
        {
          filter: [...dfilter],
        },
        () => {}
      );
    };
  };

  onLoadFlowList = () => {
    const { flowMode } = this.state;

    let dft = this.cleanFilter();

    switch (flowMode) {
      case "urge": {
        dft = [
          ...dft,
          {
            field: "urgeTime",
            hasEmpty: false,
            method: "not_empty",
            type: "urgeTime",
            value: null,
          },
        ];
        break;
      }
      case "flowExpireTime": {
        let d = BsyUtils.date2Str(new Date(), "yyyy-MM-dd HH:mm:ss");
        let now = new Date();
        now.setDate(now.getDate() + 1);
        let last = BsyUtils.date2Str(now, "yyyy-MM-dd HH:mm:ss");
        dft = [
          ...dft,
          {
            field: "flowExpireTime",
            hasEmpty: false,
            method: "range",
            type: "datetime",
            value: [d, last],
          },
        ];
        break;
      }
      case "timeout": {
        let d = BsyUtils.date2Str(new Date(), "yyyy-MM-dd HH:mm:ss");
        dft = [
          ...dft,
          {
            field: "flowExpireTime",
            hasEmpty: false,
            method: "lt",
            type: "datetime",
            value: [d],
          },
        ];
        break;
      }

      case "startAction": {
        dft = [
          ...dft,
          {
            field: "startAction",
            hasEmpty: false,
            method: "eq",
            type: "startAction",
            value: ["back"],
          },
        ];
        break;
      }
      case "lastAction": {
        dft = [
          ...dft,
          {
            field: "lastAction",
            hasEmpty: false,
            method: "eq",
            type: "lastAction",
            value: ["save"],
          },
        ];
        break;
      }
      case "isread1": {
        dft = [
          ...dft,
          {
            field: "isread",
            type: "isread",
            hasEmpty: true,
            method: "eq",
            value: [1],
          },
        ];
        break;
      }
      case "isread0": {
        dft = [
          ...dft,
          {
            field: "isread",
            type: "isread",
            hasEmpty: false,
            method: "eq",
            value: [0],
          },
        ];
        break;
      }
      case "inProcess": {
        dft = [
          ...dft,
          {
            field: "queryState",
            type: "queryState",
            hasEmpty: false,
            method: "eq",
            value: [0],
          },
        ];
        break;
      }
      case "done": {
        dft = [
          ...dft,
          {
            field: "queryState",
            type: "queryState",
            hasEmpty: false,
            method: "in",
            value: [1, 2],
          },
        ];
        break;
      }
      default: {
        break;
      }
    }

    this.props.loadFlowList && this.props.loadFlowList(dft, this.search);
  };

  //把普通字段转换成报表筛选条件的结构
  toFilterOption = (res) => {
    let asyncResultKey = "items";
    let field = res.name || res.field;
    let item = {
      ...res,
      fields: res.fields ? res.fields : [res],
      field: field,
      appId: this.props.appId,
      type: res.type, // BsyUtils._widget_dash_filter(res.type),
      asyncResultKey,
      widgetId: field,
      formId: this.props.entryId,
      height: 6,
      defaultConfig: this._margedefaultConfig(res),
      method: res.method || BsyUtils.getDashDefaultFilterMethod(res.type),
      title: res.text,
      sync: {
        url: "/data/distinct",
        data: {
          appId: this.props.appId,
          entryId: this.props.entryId,
          field: field,
          flowType: this.state.flowType,
          formId: this.props.entryId,
          hasLimit: true,
          limit: 100,
          popupFormPath: [],
          skip: 0,
          type: res.type,
        },
      },
    };
    switch (res.type) {
      case "flowcreator": {
        // item.asyncResultKey = 'creators';
        item.sync = {
          url: "/data/distinct",
          data: {
            appId: this.props.appId,
            entryId: this.props.entryId,
            field: "creator",
            flowType: this.state.flowType,
            formId: this.props.entryId,
            hasLimit: true,
            limit: 100,
            skip: 0,
            type: "user",
          },
        };
        break;
      }
      case "datetime": {
        item.format = res.format;

        switch (res.format) {
          case "yyyy-MM-dd HH:mm:ss": {
            item.type = "datetime_filter";
            break;
          }
          case "yyyy-MM-dd": {
            item.type = "date_filter";
            break;
          }
          case "yyyy-MM": {
            item.type = "datemonth_filter";
            break;
          }
          case "yyyy": {
            item.type = "dateyear_filter";
            break;
          }
          default: {
            item.format = "yyyy-MM-dd";
          }
        }

        break;
      }
      default:
    }
    return item;
  };

  //重置条件值
  reset = () => {
    // let filter = this.state.filter

    this.elementRef?.current
      ?.querySelector(".showHideFilter")
      .classList.remove("selected");

    let dda = [];
    BsyUtils.forEach(this.filterMap, (key, res) => {
      delete this.filterMap[key].defaultConfig;

      res.value = null;
      res.hasCurrentDept = false;
      res.hasCurrentParDept = false;
      res.hasCurrentSubDept = false;
      res.hasCurrentUser = false;
      res.hasEmpty = false;
      res.parentDepts = [];
      res.method = this.contextMap[res.widgetId]._getDefaultMethod();
      dda.push(res);
      this.contextMap[res.widgetId].setValue(null, res.method);
    });
    this.setState(
      {
        filter: [...dda],
      },
      () => {
        this.onLoadFlowList();
      }
    );
  };

  onSearchText = () => {
    const { filter } = this.state;
    if (this.search) {
      this.props.loadFlowList && this.props.loadFlowList(filter, this.search);
    } else {
      this.props.loadFlowList && this.props.loadFlowList(filter);
    }
  };

  cleanFilter = () => {
    let dft = this.state.filter.filter((ev) => {
      if (!ev) {
        return false;
      }

      if (
        [
          "urgeTime",
          "flowExpireTime",
          "startAction",
          "lastAction",
          "isread",
          "queryState",
        ].includes(ev.field)
      ) {
        return false;
      }
      return true;
    });
    return dft;
  };

  filterTitle = () => {
    const { flowMode, allcount } = this.state;

    // this.props.flowType == 'todo'
    switch (this.state.flowType) {
      case "todo": {
        return (
          <div className="todoFlowFilter">
            <div
              className={
                "todoMenu-item " + (flowMode === "all" ? "selected" : "")
              }
              onClick={(e) => {
                this.setState(
                  {
                    flowMode: "all",
                  },
                  () => {
                    this.onLoadFlowList();
                  }
                );
              }}
            >
              <span>{React.language("all")}</span>

              {allcount ? (
                <span className="num">
                  {"(" + (allcount ? allcount : 0) + ")"}
                </span>
              ) : (
                ""
              )}
            </div>
            <div
              className={
                "todoMenu-item " + (flowMode === "urge" ? "selected" : "")
              }
              onClick={(e) => {
                this.setState(
                  {
                    flowMode: "urge",
                  },
                  () => {
                    this.onLoadFlowList();
                  }
                );
              }}
            >
              <span>{React.language("flow.Urge")}</span>
              <span className="num"></span>
            </div>
            <div
              className={
                "todoMenu-item " +
                (flowMode === "flowExpireTime" ? "selected" : "")
              }
              onClick={(e) => {
                this.setState(
                  {
                    flowMode: "flowExpireTime",
                  },
                  () => {
                    this.onLoadFlowList();
                  }
                );
              }}
            >
              <span>{React.language("about.to.time.out")}</span>
            </div>
            <div
              className={
                "todoMenu-item " + (flowMode === "timeout" ? "selected" : "")
              }
              onClick={(e) => {
                this.setState(
                  {
                    flowMode: "timeout",
                  },
                  () => {
                    this.onLoadFlowList();
                  }
                );
              }}
            >
              <span>{React.language("timeout")}</span>
            </div>

            <div
              className={
                "todoMenu-item " +
                (flowMode === "startAction" ? "selected" : "")
              }
              onClick={(e) => {
                this.setState(
                  {
                    flowMode: "startAction",
                  },
                  () => {
                    this.onLoadFlowList();
                  }
                );
              }}
            >
              <span>{React.language("flow.action.back")}</span>
            </div>

            <div
              className={
                "todoMenu-item " + (flowMode === "lastAction" ? "selected" : "")
              }
              onClick={(e) => {
                this.setState(
                  {
                    flowMode: "lastAction",
                  },
                  () => {
                    this.onLoadFlowList();
                  }
                );
              }}
            >
              <span>{React.language("flow.action.save")}</span>
            </div>
          </div>
        );
      }
      case "cc": {
        return (
          <div className="todoFlowFilter">
            <div
              className={
                "todoMenu-item " + (flowMode === "all" ? "selected" : "")
              }
              onClick={(e) => {
                this.setState(
                  {
                    flowMode: "all",
                  },
                  () => {
                    this.onLoadFlowList();
                  }
                );
              }}
            >
              <span>{React.language("all")}</span>
              {allcount ? (
                <span className="num">
                  {"(" + (allcount ? allcount : 0) + ")"}
                </span>
              ) : (
                ""
              )}
            </div>
            <div
              className={
                "todoMenu-item isread0 " +
                (flowMode === "isread0" ? "selected" : "")
              }
              onClick={(e) => {
                this.setState(
                  {
                    flowMode: "isread0",
                  },
                  () => {
                    this.onLoadFlowList();
                  }
                );
              }}
            >
              <span>{React.language("unread")}</span>
            </div>
            <div
              className={
                "todoMenu-item " + (flowMode === "isread1" ? "selected" : "")
              }
              onClick={(e) => {
                this.setState(
                  {
                    flowMode: "isread1",
                  },
                  () => {
                    this.onLoadFlowList();
                  }
                );
              }}
            >
              <span>{React.language("read")}</span>
            </div>
          </div>
        );
      }

      default:
        return (
          <div className="todoFlowFilter">
            <div
              className={
                "todoMenu-item " + (flowMode === "all" ? "selected" : "")
              }
              onClick={(e) => {
                this.setState(
                  {
                    flowMode: "all",
                  },
                  () => {
                    this.onLoadFlowList();
                  }
                );
              }}
            >
              <span>{React.language("all")}</span>

              {allcount ? (
                <span className="num">
                  {"(" + (allcount ? allcount : 0) + ")"}
                </span>
              ) : (
                ""
              )}
            </div>
            <div
              className={
                "todoMenu-item " + (flowMode === "inProcess" ? "selected" : "")
              }
              onClick={(e) => {
                this.setState(
                  {
                    flowMode: "inProcess",
                  },
                  () => {
                    this.onLoadFlowList();
                  }
                );
              }}
            >
              <span>{React.language("flow.state.inProcess")}</span>
            </div>
            <div
              className={
                "todoMenu-item " + (flowMode === "done" ? "selected" : "")
              }
              onClick={(e) => {
                this.setState(
                  {
                    flowMode: "done",
                  },
                  () => {
                    this.onLoadFlowList();
                  }
                );
              }}
            >
              <span>{React.language("doned")}</span>
            </div>
          </div>
        );
    }
  };

  render() {
    const {
      show,
      filter,
      fields,
      seachSwitch,
      flowMode,
      flowType,
      updateTime,
      isBatchForward,
    } = this.state;

    let filterList = [];
    let hasFilterValue = false;
    BsyUtils.forEach(filter, (key, res) => {
      if (res) {
        if (res.value) {
          hasFilterValue = true;
        }
        fields.map((res1) => {
          if (res.field === res1.name) {
            if (!this.filterMap[res.field]) {
              //兼容老数据，如果存储fields 说明是新的格式
              const item = this.toFilterOption(
                res.field
                  ? { ...res, format: res1.format, text: res1.text }
                  : res1
              );
              this.filterMap[res.field] = { ...item };
              this.filter[res.field] = { ...res };
              filterList.push(item);
            } else {
              filterList.push(this.filterMap[res.field]);
            }
          }
          return null;
        });
      }
    });
    return (
      <>
        <div className={"flowFilterHeader " + flowMode} ref={this.elementRef}>
          <div className="filterTitle">
            {/* {React.language("filter.addCondition")} */}

            {this.filterTitle()}
          </div>
          <div className="filter-header-right">
            {seachSwitch ? (
              <BsySearchInput
                placeholder={React.language("search.flow")}
                styleInput={{
                  width: "200px",
                }}
                value={this.search}
                onSearch={(val) => {
                  if (val) {
                    this.search = val;
                  } else {
                    this.search = null;
                  }
                  this.onSearchText();
                }}
                type={window.mode}
                // iconName="icon-bsy-reportmenu-0"
              ></BsySearchInput>
            ) : (
              ""
            )}

            {flowMode === "isread0" ? (
              <div
                className="right-item menu-readAll"
                onClick={(e) => {
                  this.readAll();
                }}
              >
                <div className="new">
                  <i className="icon-bsy-cc-read" />
                  <span>{React.language("msg.readAll")}</span>
                </div>
              </div>
            ) : (
              ""
            )}

            <div
              className={`right-item showHideFilter ${show ? "show" : "hide"} ${
                hasFilterValue ? "selected" : ""
              }  ${this.props.entryId ? "" : "disabled"}`}
              onClick={this.switchShowHide}
            >
              <i className={"icon-bsy-shaixuananniu"}></i>
              <span>{React.language("filter")}</span>
            </div>

            <div
              className="right-item menu-sort"
              onClick={this.props?.sortTime}
            >
              <i className="icon-bby-iconpaixu" />
              <span>
                {updateTime === -1
                  ? React.language("latest")
                  : React.language("earliest")}
              </span>
            </div>

            <div
              className="right-item menu-refresh"
              onClick={(e) => {
                this.props?.refreshLoad();
              }}
            >
              <i className="icon-async" />
              <span>{React.language("refresh")}</span>
            </div>
            {["todo"].indexOf(flowType) > -1 && (
              <div
                className={`right-item menu-batch ${
                  isBatchForward ? "show" : ""
                } ${this.props.entryId ? "" : "disabled"}`}
                onClick={(e) => {
                  this.props?.switchBatchForward(!isBatchForward);
                }}
              >
                <i className="icon-batch" />
                <span>{React.language("flow.action.batchForward")}</span>
              </div>
            )}
          </div>
        </div>
        <div
          className="flowFilterContent"
          style={{ display: show ? "block" : "none" }}
        >
          <div className="filterContent">
            {filterList.length > 0 && (
              <div className="filterList">
                {filterList.map((res, key) => {
                  return (
                    <div className={"filterItem " + res.type} key={res.field}>
                      <div className="removeFilterItem">
                        <i
                          className="icon-bsy-close-small"
                          onClick={this.removeFilterItem(res, key)}
                        ></i>
                      </div>
                      {this.loadFilterList(res)}
                    </div>
                  );
                })}
              </div>
            )}
            <div className={`filterAddTo ${filterList.length ? "show" : ""}`}>
              <div className="filterAddBtn" onClick={this.selectField}>
                <i className="icon-bsy-add"></i>
                <span>{React.language("platform.flow.filter.add")}</span>
              </div>
              <div className="reFilter">
                {filterList.length > 0 && (
                  <div className="reBtn" onClick={this.reset}>
                    {React.language("richtext.reset")}
                  </div>
                )}
                <div className="filterBtn" onClick={this.onLoadFlowList}>
                  {React.language("filter")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default BsyDashboardFlowFilter;
